/**
 * Utility functions for handling status-related operations
 */

/**
 * Filters an array of items to only include active items
 * @param {Array} items - Array of items to filter
 * @param {Object} options - Configuration options
 * @param {string} options.statusField - The field name that contains the status value (default: 'status')
 * @param {string|number} options.activeValue - The value that represents active status (default: '1')
 * @returns {Array} Filtered array containing only active items
 */
export const getActiveItems = (items, options = {}) => {
  const { statusField = "status", activeValue = "1" } = options;

  if (!Array.isArray(items)) {
    console.warn("getActiveItems: items parameter must be an array");
    return [];
  }

  return items.filter((item) => item[statusField] === activeValue);
};

/**
 * Formats a status value for display
 * @param {string|number} status - The status value to format
 * @param {Object} options - Configuration options
 * @param {string|number} options.activeValue - The value that represents active status (default: '1')
 * @returns {string} Formatted status string ('Active' or 'Inactive')
 */
export const formatStatus = (status, options = {}) => {
  const { activeValue = "1" } = options;
  return status === activeValue ? "Active" : "Inactive";
};

/**
 * Gets the appropriate CSS class for a status badge
 * @param {string|number} status - The status value
 * @param {Object} options - Configuration options
 * @param {string|number} options.activeValue - The value that represents active status (default: '1')
 * @returns {string} CSS class for the status badge
 */
export const getStatusBadgeClass = (status, options = {}) => {
  const { activeValue = "1" } = options;
  return status === activeValue
    ? "bg-success-subtle text-success"
    : "bg-danger-subtle text-danger";
};
